import apiClient from '../index'

export const addLocation = (data) => apiClient.post('/location', data)
export const getLocationMetadata = () => apiClient.get('/location/metadata')

export const getLocation = (skip, limit, isActive, searchLocationName) =>
  apiClient.get('/location', {
    params: {
      skip,
      limit,
      isActive,
      searchLocationName,
    },
  })

export const updateLocation = (id, data) => apiClient.patch(`/location/${id}`, { data })
